interface OptionsListProps {
  options: [string, string, string, string];
  selectedIndex: number | null;
  correctIndex?: number;
  disabled: boolean;
  revealed?: boolean;
  onSelect: (index: number) => void;
}

const LETTERS = ['A', 'B', 'C', 'D'];

export default function OptionsList({
  options,
  selectedIndex,
  correctIndex,
  disabled,
  revealed,
  onSelect,
}: OptionsListProps) {
  const getClassName = (idx: number) => {
    const classes = ['opt-btn'];
    if (disabled) classes.push('disabled');
    if (revealed && idx === correctIndex) classes.push('correct');
    if (revealed && idx === selectedIndex && idx !== correctIndex) classes.push('wrong');
    if (!revealed && idx === selectedIndex) classes.push('selected');
    return classes.join(' ');
  };

  return (
    <div className="options-list">
      {options.map((opt, i) => (
        <button
          key={i}
          className={getClassName(i)}
          onClick={() => onSelect(i)}
          disabled={disabled}
        >
          <span className="opt-letter">{LETTERS[i]}</span>
          {opt}
        </button>
      ))}
    </div>
  );
}
